var map = {
	"./DEEP KIK_1.wav": 66,
	"./Guita_1.wav": 67,
	"./HI_1.wav": 68,
	"./ORGAN BASS_1.wav": 69,
	"./P.wav": 70,
	"./PIANO RIFFY_1.wav": 71,
	"./TWSL - DRUM_1.wav": 72,
	"./TWSL - LOOP_1.wav": 73,
	"./organ breakdown_1.wav": 74,
	"./vocals2.wav": 75,
	"./vocals_1.wav": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;